module.exports = __webpack_public_path__ + "img/Slovak Republic.54bfce62.gif";